<template>
  <v-container fluid>
    <v-toolbar flat color="#FAFAFA">
      <v-btn icon outline color="black" to="/produtos">
        <v-icon>arrow_back</v-icon>
      </v-btn>
      <v-toolbar-title >Gerenciador de Áudio </v-toolbar-title>
      <v-spacer></v-spacer>

      <v-btn color="green" dark @click="$refs.artist_info_ref.salvar()">salvar</v-btn>
    </v-toolbar>

    <template>
      <auditie :product_id="item_id" ref="audities" />
      <!--artista_info :artist_id="item_id" ref="artist_info_ref"/-->
    </template>
  </v-container>
</template>


<script>
import auditie from "../../../components/produtos/audio/auditie";

export default {
  components: {
    auditie
  },
  data() {
    return {
      item_id: 0
    };
  },
  beforeCreated() {},
  created() {
    this.item_id = this.$route.params.id;
  },
  mounted() {},
  beforeDestroy() {},
  destroy() {}
};
</script>